import hljs from 'highlight.js/lib/core';
import bash from 'highlight.js/lib/languages/bash';
import csharp from 'highlight.js/lib/languages/csharp';
import json from 'highlight.js/lib/languages/json';
import http from 'highlight.js/lib/languages/http';
import powershell from 'highlight.js/lib/languages/powershell';
import 'highlight.js/styles/github-dark.css';

hljs.registerLanguage('bash', bash);
hljs.registerLanguage('shell', bash);
hljs.registerLanguage('csharp', csharp);
hljs.registerLanguage('json', json);
hljs.registerLanguage('http', http);
hljs.registerLanguage('powershell', powershell);

document.querySelectorAll('#api-doc-content pre code').forEach((el) => {
  hljs.highlightElement(el as HTMLElement);
});
